import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import withCSRF from '../../../commonComponents/withCSRF';
import translate from '../../../commonComponents/translate';
import GoogleInput from '../../../commonComponents/forms/inputs/GoogleInput';
import AccessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';

const PlaceLocation = ({ t, accessSession, isFinished, address, handleChange }) => (
  <div className="row">
    <div className="col-lg-12 input-classroom form-group m-form__group row">
      <label
        htmlFor="address"
        className="col-form-label col-2 text-right"
      >
        {t('access_session.detail.placeLocation')}
      </label>
      <div className="col-8">
        <GoogleInput
          placeholder={t('access_session.detail.placeLocation.placeholder')}
          updateValue={address}
          id="placeLocation"
          name="placeLocation"
          defaultValue={accessSession.classroom?.placeLocation || ''}
          endpoint="/api/address/places/autocomplete"
          onChange={handleChange('address')}
          disabled={isFinished}
          onSetValue={handleChange('placeLocation')}
          onPlaceLocationSelection={handleChange('placeLocation')}
        />
      </div>
    </div>
  </div>
);

PlaceLocation.propTypes = {
  t: PropTypes.func.isRequired,
  accessSession: PropTypes.shape(AccessSessionProp.propType).isRequired,
  isFinished: PropTypes.bool,
  address: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

PlaceLocation.defaultProps = {
  isFinished: false,
  address: '',
};

export default compose(
  translate,
  withCSRF,
)(PlaceLocation);
